import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LaboratoryService } from '../../../laboratory.service';
import {
  ILaboratoryBase,
  LABORATORY_TTL_ES
} from '../../../laboratory.interface';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
@Component({
  selector: 'pg-laboratory-create',
  templateUrl: './laboratory-create.component.html'
})
export class LaboratoryCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  constructor(private fb: FormBuilder, private serviceBase: LaboratoryService) {
    super(LABORATORY_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      description: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ]
    });
  }

  onSubmit() {
    this.createItem$(this.fg.value as ILaboratoryBase);
  }
}
